import React from 'react'
import { browserHistory } from 'react-router'
import { modal } from '../../core/utilities/modal'
import { spaces } from '../../core/controllers/Spaces'
import { multiTaskerManager } from '../../core/controllers/MultiTaskerManager'

import SingleTask from './SingleTask'

export default class TaskBarTemplate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            justSliced: false
        }
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextState.justSliced) {
            nextState.justSliced = false;
        }
    }

    closeTask(position) {
        multiTaskerManager.removeOne(position);
        this.setState({
            justSliced: true
        });
    }

    render(){
        var self = this;
        const tasks = multiTaskerManager.taskObjs;
        return (
            <div class="col-md-10" id="task-bar-manager">
                {tasks != null && tasks.length != 0 && (
                    tasks.map(function(task, index){
                        return <SingleTask key={index} position={index} data={task.data} closeTask={self.closeTask.bind(self, index)} type={task.type} />
                    })
                )}
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/MultiTaskManager/TaskBar.jsx